import { create } from 'zustand';
import {
  type CopilotValue1,
  type CopilotValue2,
  type CopilotValue3,
  type CopilotValue4,
  type CopilotValue17,
  type CopilotValue8,
  type CopilotValue9,
  type CopilotValue10,
  type CopilotValue11,
  type CopilotValue22
} from './types/copilotValue';

export const defaultCopilotValue8: CopilotValue8 & { loading: boolean } = {
  content: '',
  keyWord: '',
  product_info: [],
  一句话解读: '',
  标签描述: '',
  标签解析: '',
  分析总结: '',
  综合投资建议: '',
  趋势表现: '',
  风险提示: '',
  loading: true
};

export const defaultCopilotValue9: CopilotValue9 & { loading: boolean } = {
  content: '',
  keyWord: '',
  product_info: [],
  历史业绩: '',
  投资策略: '',
  持仓分析: '',
  收益表现对比: '',
  风险提示: '',
  风险评估对比: '',
  loading: true
};

export const defaultCopilotValue10: CopilotValue10 & { loading: boolean } = {
  content: '',
  keyWord: '',
  product_info: [],
  一句话解读: '',
  产品优势: '',
  分析总结: '',
  收益与回撤概览: '',
  风险提示: '',
  loading: true
};

export const defaultCopilotValue11: CopilotValue11 & { loading: boolean } = {
  content: '',
  keyWord: '',
  industry_trend_analysis: '',
  investment_recommendations: '',
  leading_enterprise_analysis: '',
  policy_environment_analysis: '',
  loading: true
};
/**
   1, 客户画像agent请求结果
   2, 客户画像额外信息请求结果
   3, 持仓诊断agent请求结果
   4, 资产配置agent请求结果
   8, 产品信息-产品推荐agent请求
   9, 产品信息-产品对比agent请求
   10, 产品信息-产品解读agent请求
   11, 投顾洞察-市场解读agent请求
   16, 趋势走向
   17, 市场分析
 */

interface CopilotValueStore {
  copilotValue1: CopilotValue1;
  updateCopilotValue1: (data: Partial<CopilotValue1>) => void;
  copilotValue2: CopilotValue2;
  updateCopilotValue2: (data: Partial<CopilotValue2>) => void;
  copilotValue3: Partial<CopilotValue3>;
  updateCopilotValue3: (data: Partial<CopilotValue3>) => void;
  copilotValue4: Partial<CopilotValue4>;
  updateCopilotValue4: (data: Partial<CopilotValue4>) => void;
  copilotValue8: CopilotValue8 & { loading: boolean };
  updateCopilotValue8: (data: Partial<CopilotValue8 & { loading: boolean }>) => void;
  copilotValue9: CopilotValue9 & { loading: boolean };
  updateCopilotValue9: (data: Partial<CopilotValue9 & { loading: boolean }>) => void;
  copilotValue10: CopilotValue10 & { loading: boolean };
  updateCopilotValue10: (data: Partial<CopilotValue10 & { loading: boolean }>) => void;
  copilotValue11: CopilotValue11 & { loading: boolean };
  updateCopilotValue11: (data: Partial<CopilotValue11 & { loading: boolean }>) => void;
  copilotValue17: CopilotValue17;
  updateCopilotValue17: (data: Partial<CopilotValue17>) => void;
  copilotValue22: CopilotValue22 & { loading?: boolean };
  updateCopilotValue22: (data: Partial<CopilotValue22> & { loading: boolean }) => void;
}

const useCopilotValueStore = create<CopilotValueStore>(set => ({
  copilotValue1: {
    investment_behavior_analysis: '',
    position_analysis: '',
    profile_summary: '',
    user_tags: ''
  },
  updateCopilotValue1: data =>
    set(state => ({
      copilotValue1: {
        ...state.copilotValue1,
        ...data
      }
    })),
  copilotValue2: {
    dataType: '',
    customerInfo: []
  },
  updateCopilotValue2: data =>
    set(state => ({
      copilotValue2: {
        ...state.copilotValue2,
        ...data
      }
    })),
  copilotValue3: {},
  updateCopilotValue3: data =>
    set(state => ({
      copilotValue3: {
        ...state.copilotValue3,
        ...data
      }
    })),
  copilotValue4: {},
  updateCopilotValue4: data =>
    set(state => ({
      copilotValue4: {
        ...state.copilotValue4,
        ...data
      }
    })),
  copilotValue8: defaultCopilotValue8,
  updateCopilotValue8: data =>
    set(state => ({
      copilotValue8: {
        ...state.copilotValue8,
        ...data
      }
    })),
  copilotValue9: defaultCopilotValue9,
  updateCopilotValue9: data =>
    set(state => ({
      copilotValue9: {
        ...state.copilotValue9,
        ...data
      }
    })),
  copilotValue10: defaultCopilotValue10,
  updateCopilotValue10: data =>
    set(state => ({
      copilotValue10: {
        ...state.copilotValue10,
        ...data
      }
    })),
  copilotValue11: defaultCopilotValue11,
  updateCopilotValue11: data =>
    set(state => ({
      copilotValue11: {
        ...state.copilotValue11,
        ...data
      }
    })),
  copilotValue17: {
    dataType: '',
    market_analysis: []
  },
  updateCopilotValue17: data =>
    set(state => ({
      copilotValue17: {
        ...state.copilotValue17,
        ...data
      }
    })),
  copilotValue22: {
    loading: false,
    ID: '',
    工具推荐: [],
    标签: '',
    标签属性: ''
    // market_analysis: []
  },
  updateCopilotValue22: data =>
    set(state => ({
      copilotValue22: {
        ...state.copilotValue22,
        ...data
      }
    }))
}));

export default useCopilotValueStore;
